import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';
import MessageBlock from '@marvelapp/marvel-ui/message-block';

export default function FormSuccess({ message }) {
  return (
    <Spacing type="margin" position="top" size="m">
      <MessageBlock textAlign="left" type="success" fullWidth>
        {message}
      </MessageBlock>
    </Spacing>
  );
}

FormSuccess.propTypes = {
  message: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/FormSuccess/index.js